import React from "react";
import { FaPlus, FaEye, FaEdit, FaTrashAlt, FaSearch } from "react-icons/fa"; // Importing icons from React Icons
import "./HomePage.css";

function HomePage() {
  return (
    <div className="home-content">
      <h1>Welcome to Our Application</h1>
      <p>
        Manage your posts efficiently with our powerful features:
      </p>
      <ul className="feature-list">
        <li>
          <FaPlus className="icon" /> <b>Create:</b> Add new posts effortlessly.
        </li>
        <li>
          <FaEye className="icon" /> <b>Read:</b> Retrieve and view existing posts.
        </li>
        <li>
          <FaEdit className="icon" /> <b>Edit:</b> Modify content of your posts whenever needed.
        </li>
        <li>
          <FaTrashAlt className="icon" /> <b>Delete:</b> Remove unwanted posts.
        </li>
        <li>
          <FaSearch className="icon" /> <b>Search:</b> Quickly find specific posts.
        </li>
      </ul>
    </div>
  );
}

export default HomePage;
